export enum BookingType {
  IsHours = 0,
  IsDays = 1,
  IsWeeks = 2,
  IsMonths = 3,
  IsYears = 4,
}

export const BookingTypeLabels: Record<BookingType, string> = {
  [BookingType.IsHours]: "Hourly",
  [BookingType.IsDays]: "Daily",
  [BookingType.IsWeeks]: "Weekly",
  [BookingType.IsMonths]: "Monthly",
  [BookingType.IsYears]: "Yearly",
};
